import React from 'react'
import {
  getStoryblokRequest,
  StoryblokComponent,
} from '@crunchyroll/cr-static-shared-components'

const getAllStoryblokRequests = (allRequests, lang) => {
  if (!allRequests) return false

  return (
    allRequests &&
    allRequests.endpoints &&
    allRequests.endpoints.map(async ({ url, params }) => {
      const request = await getStoryblokRequest(url, params, lang)
      return request()
    })
  )
}

const renderTextBlok = ({ blok, as, className }) => {
  if (blok?.length < 1) return null

  return blok?.map((content) => (
    <StoryblokComponent
      key={content._uid}
      blok={content}
      as={as}
      className={className}
    />
  ))
}

export { getAllStoryblokRequests, renderTextBlok }
